import styled from "styled-components";
import { theme, size } from "../../../../helpers/theme";
import check from "../../../../assets/icons/check.svg";

export type IterationProps = {
    value: string;
    isImage: boolean;

};


export const Iterations = (props: IterationProps) => {

    return (

        <Iteration>
            {props.isImage ? <IterationSvg src={check} /> : < IterationNoSvg />}
            <IterationText>{props.value}</IterationText>
        </Iteration >

    );
};


const Iteration = styled.div`
padding:3px 0px;
display: flex;
flex-direction: row;
align-items: center;
align-items: flex-start;
min-width:300px;
@media (max-width: ${size.laptop}) {
    min-width: 230px;
    }
`
const IterationSvg = styled.img`
margin-right:13px;
width:14px;
height:14px;
`;
const IterationNoSvg = styled.div`
width:14px;
height:14px;
margin-right:13px;
`;
const IterationText = styled.div`
max-width:200px;
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.small};
font-size: 14px;
line-height: 20px;
max-width: fit-content;
`;

